<template>
    <div class="lni-c-form-control lni-c-currency-input"
        :class="[{
            'lni-c-form-control--required': required,
            'lni-c-form-control--inline': inline,
            'lni-c-form-control--custom-width': customWidth
        },
        this.class
        ]"
    >

        <label :for="controlId" class="lni-c-form-control__label" :class="{ 'lni-u-visually-hidden': hideLabel }">{{ labelText }}</label>
        <slot />
        <input
            class="lni-c-form-control__input lni-c-currency-input__input"
            type="number"
            :id="controlId"
            :name="controlId"
            :required="required"
            :maxlength="maxlength"
            :step=".01"
            :pattern="decimalPattern.source"
            @change="handleErrorState"
            @input="onInput"
            @wheel.prevent
            @keydown.up.down.prevent>
    </div>
</template>

<script>
import framework from '../../framework';

/**
*  The x-input-currency component.
*  @module components/x-input-currency
*/


/**
* This component represents a basic currency input with a label.
*/
export default {
    name: 'x-input-currency',
    props: {
        dataLabelText: String,
        hideLabel: Boolean,
    },
    mixins: [
        framework.mixins.abstractSingleValueInput,
    ],
    data() {
        return {
            decimalPattern: /^(\d+\.?\d{0,2}|\.\d{1,2})$/,
        };
    },
    mounted() {
        this.initialize();
    },
    computed: {
        /**
        * The text for the label.
        * @returns {string} label text.
        */
        labelText() {
            return this.getAttribute('labelText', '');
        },
        /**
        * The placeholder for the input.
        * @returns {string} placeholder text.
        */
        placeholder() {
            return this.getAttribute('placeholder', '');
        },
    },
    methods: {
        /**
        * Handles the input event and sets the changed value onto the component's model.
        * @param {*} event the input event
        * @returns {void}
        */
        onInput(event) {
            if (this.maxlength && event.target.value.length >= this.maxlength) {
                event.target.value = event.target.value.slice(0, this.maxlength);
            }
            this.value = event.target.value;
        },
        /**
        * Gets the error information off of the input element(s)
        * @returns {void}
        */
        getErrorStateOffInputs() {
            return this.getSimpleErrorStateOffInputs('input');
        },
        /**
         * Put the values onto the Html Inputs
         * @returns {void}
         */
        initializeHtmlInputs() {
            if (this.componentValue) {
                let el = this.$el.querySelector(`input`);
                el.value = this.componentValue;
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// source/components/x-input-currency/x-input-currency.vue